export default __webpack_public_path__ + "static/media/Shadow's Jerkin of the Nadir.e920e683.jpg";